<template>
    <div class='login-box'>
        <div class="login-box-logo">
            <img src='https://server.cottongame.com/serverstore/service/logo.png' alt=''>
            <h3>CottonGame</h3>
        </div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="login-form">
            <el-form-item prop="account" key='account'>
                <el-input size='medium' type='text'
                          :placeholder="$t('login.enterPhoneOrAccount') || '请输入手机号或账号或邮箱'"
                          autocomplete='off'
                          v-model='ruleForm.account'></el-input>
            </el-form-item>
            <el-form-item prop="password" key='password'>
                <el-input size='medium' type='password' show-password
                          :placeholder="$t('login.enterPassword') || '请输入密码'" v-model='ruleForm.password'
                          autocomplete='off'></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size='medium' style='width: 100%' type='primary' @click='submitForm'>
                    {{ $t('login.login') || '登录' }}
                </el-button>
            </el-form-item>
            
            <el-divider content-position='center'>{{ $t('common.or') || '或者使用以下方式' }}</el-divider>
            <el-row :gutter='10'>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('phoneLogin')">{{ $t('login.phoneLogin') || '短信登录' }}
                    </el-button>
                </el-col>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('emailLogin')">{{ $t('login.emailLogin') || '邮箱登录' }}
                    </el-button>
                </el-col>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('register')">{{ $t('login.createAccount') || '创建账号' }}
                    </el-button>
                </el-col>
                <el-col :span='6'>
                    <el-button type='text' @click="skipPage('forgetPwd')">{{ $t('login.forgetPassword') || '忘记密码'
                        }}
                    </el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from '@/utils/message';
import { loginApi } from '@/service/api/loginApi';
import { localStg } from '@/utils/storage/local';
import { EnumLocalStore } from '@/constant/enums';

export default defineComponent({
    name: 'Login',
    data() {
        let validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('login.enterPassword') || '请输入密码'));
            } else {
                callback();
            }
        };
        let validateAccount = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('login.enterPhoneOrAccountHint') || '请输入手机号或者账号'));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                password: '',
                account: ''
            },
            rules: {
                account: [
                    { validator: validateAccount, trigger: 'blur' }
                ],
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ],
            },
            operatorType: 0
        };
    },
    created() {
        if (localStg.get(EnumLocalStore.jwtTokenName)) {
            this.$router.push('/')
        }
    },
    methods: {
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    // 判断是手机号还是账号
                    loginApi.playerLogin(this.ruleForm).then(result => {
                        if (result.code === 200) {
                            message.success(this.$t('login.loginSuccess') || '登录成功');
                            // 进入首页
                            let data = result.data
                            localStg.set(EnumLocalStore.jwtTokenName, data.token)
                            localStg.set('account', data.data.account)
                            localStg.set('userId', data.data.userId)
                            localStg.set('platformId', data.data.platformId)
                            this.$router.push('/')
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        
        skipPage(router) {
            this.$router.push(router)
        }
    }
});
</script>

<style lang='css'>
@import "../../assets/css/login.css";
</style>
